import { render, staticRenderFns } from "./project-add.vue?vue&type=template&id=bee9a40c&scoped=true&"
import script from "./project-add.vue?vue&type=script&lang=js&"
export * from "./project-add.vue?vue&type=script&lang=js&"
import style0 from "./project-add.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./project-add.vue?vue&type=style&index=1&id=bee9a40c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee9a40c",
  null
  
)

export default component.exports